module.exports = __webpack_public_path__ + "img/AR.196d9424.jpg";